// extracted by mini-css-extract-plugin
module.exports = {"chart":"UserChart_chart__1oMFm"};